module.exports = __webpack_public_path__ + "img/phone-alt.d283c728.svg";